import React from "react";
import { ShortcutGroup } from "modules/shortcuts/models";
import AutocompleteSearch from "modules/common/components/autocompleteSearch";
import LoadingCircle from "modules/common/components/loadingCircle";
import { useSelector } from "react-redux";
import { GlobalApplicationState } from "globalApplicationState";

interface IShortcutGroupSearchProps {
    shortcutGroupValue: ShortcutGroup | undefined;
    onChangeShortcutGroupValue: (newGroup: ShortcutGroup | null) => void;
}

const ShortcutGroupSearch: React.FC<IShortcutGroupSearchProps> = ({
    shortcutGroupValue,
    onChangeShortcutGroupValue
}) => {
    const { originalShortcutFormat, isLoadingOriginalShortcutFormat } = useSelector((state: GlobalApplicationState) => state.shortcuts);
    const allShortcutGroups = originalShortcutFormat.flatMap(f => f.shortcutGroup);

    return <AutocompleteSearch
        searchableItems={allShortcutGroups}
        currentItem={shortcutGroupValue ?? { id: "empty-id", name: "" }}
        onChange={item => onChangeShortcutGroupValue(allShortcutGroups.find(sg => sg.id === item?.id) ?? null)}
        placeholderText="Search and select shortcut group"
        isLoading={isLoadingOriginalShortcutFormat}
        isLoadingText={<div style={{ display: 'flex', justifyContent: "center" }}><LoadingCircle size="20px"/></div>}
    />;
};

export default ShortcutGroupSearch;
